import { useQuery } from '@tanstack/react-query';

import { getQRCodeFolders } from '~/api/qrCodeFolders';
import { folderKeys } from '~/constants/queryKeys';

export default function useQrCodeFolders() {
  return useQuery({
    queryFn: getQRCodeFolders,
    queryKey: folderKeys.allFolders,
    select: (response) => response.data,
  });
}
